import type { AccountSummary, OnboardingChatResults } from '@fruitful/types';
import { atom } from 'jotai';

export const selectedManualInstitutionAtom = atom<string | null>(null);
export const selectedManualAccountAtom = atom<AccountSummary | null>(null);

export const magicNumbersOnboardingIncomeAtom = atom<number | null>(null);
export const magicNumbersOnboardingBillsAtom = atom<number | null>(null);

export const confirmedReviewResultsAtom = atom<OnboardingChatResults | null>(
    null,
);
